// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import { stringify } from 'query-string';
import HttpService from 'src/lib/HttpService';
const DEFAULT_ADDRESS_VALIDATION_URL = `api/ustrl/v1.0/api/address`;
const DEFAULT_WIC_ADDRESS_URL = `api/ustrl/v1.0/api/location/wic`;

export interface AddressRequest {
    address1: string;
    address2: string;
    city: string;
    postalCode: string;
    stateOrProvince: string;
    country: string;
}

export interface WicRequest {
    city: string;
    province: string;
    country: string;
}

export default {
    async getValidatedAddresses(request: AddressRequest) {
        const {
            address1,
            address2,
            city,
            postalCode,
            stateOrProvince,
            country,
        } = request;
        const requestQuery = stringify({
            address1,
            address2,
            city,
            postalCode,
            stateOrProvince,
            country,
        });

        const response = await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_ADDRESS_VALIDATION_URL}?${requestQuery}`,
            type: 'get',
        });
        return response;
    },

    async getWicAddresses(request: WicRequest) {
        const { city, province: state, country } = request;

        const requestQuery = stringify({ city, state, country });

        const response = await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_WIC_ADDRESS_URL}?${requestQuery}`,
            type: 'get',
        });

        return response;
    },
};
